import React, { useState, Fragment } from "react";
import { Menu, MenuHandler, MenuItem, MenuList, Tooltip } from '@material-tailwind/react';
import { GiftIcon, InfoIcon2, SettingIcon } from "../../Assets/AllSvg";
import { IoChevronDownOutline, IoChevronUpOutline } from 'react-icons/io5'
import { BiRightArrowAlt } from "react-icons/bi";
import { Listbox, Transition } from "@headlessui/react";
import { HiChevronUpDown } from "react-icons/hi2";

const Taxrate = [
  { id: 1, name: 'Select a tax rate...' },
]

const Coupon = [
  { id: 1, name: 'Select a coupon...' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const EditInvoiceItemList = ({ item, editItemId, setEditItemId, invoiceList, setInvoiceList }) => {
  const [items, setItems] = useState({
    field: false,
    value: '',
    setting: false,
    options: false,
    checkbox: false,
    saveItem: false,
    addField: false,
  })
  const [taxrate, setTaxrate] = useState(Taxrate[0])
  const [addC, setAddC] = useState(Coupon[0])
  const [itemObj, setItemObj] = useState({
    item: item.item,
    qty: item.qty,
    price: item.price
  })

  const handleOnchangeSave = () => {
    const data = invoiceList.map((val, i) => {
      if (i === editItemId) {
        val.item = itemObj.item
        val.qty = itemObj.qty
        val.price = itemObj.price
      }
      return val
    })
    setInvoiceList(data)
    setEditItemId('')
  }

  return (
    <>
      <div className="mt-5">
        <div className="border-b-[1px] border-[#ebeef1] pb-5">
          <div className="flex justify-between items-center">
            <span className="text-base text-[#414552] font-semibold">
              Item details
            </span>
            <span className="text-base text-[#414552] font-semibold">
              ${itemObj.price * (itemObj.qty ? itemObj.qty : 1)}.00
            </span>
          </div>
          <div className="mt-4 flex gap-3 items-center">
            <div className="w-full">
              <label className="text-sm font-medium text-[#414552]">Item</label>
              <input
                value={itemObj.item}
                onChange={(e) => setItemObj({ ...itemObj, item: e.target.value })}
                type="text"
                className="mt-1 input_focus_shadow text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
              />
            </div>
            <div className="w-[120px]">
              <label className="text-sm font-medium text-[#414552]">Qty</label>
              <input
                value={itemObj.qty}
                onChange={(e) => setItemObj({ ...itemObj, qty: e.target.value })}
                type="number"
                className="mt-1 input_focus_shadow text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                defaultValue="1"
              />
            </div>
            {!items.setting && (
              <div className="w-[120px]">
                <div className="flex items-center gap-1">
                  <label className="text-sm font-medium text-[#414552]">
                    Price
                  </label>
                  {items.value === "create" && (
                    <Menu placement="bottom-end">
                      <MenuHandler>
                        <button>
                          <SettingIcon className="w-[12px] h-[12px] fill-gray-600" />
                        </button>
                      </MenuHandler>
                      <MenuList className="outline-remove px-0 py-[8px] min-w-[190px]">
                        <MenuItem
                          className="py-[4px] hover:bg-[#f6f8fa] rounded-none px-[8px] text-[#625afa] font-medium"
                          onClick={() => setItems({ ...items, setting: true })}
                        >
                          Switch to package pricing
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  )}
                </div>
                <div className="relative w-full">
                  <input
                    value={itemObj.price}
                    onChange={(e) => setItemObj({ ...itemObj, price: e.target.value })}
                    type="number"
                    className="mt-1 input_focus_shadow text-[#404552] font-normal px-2 pl-6 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                    defaultValue="0"
                  />
                  <span className="absolute left-2 top-[7px] text-[#404552]">
                    $
                  </span>
                </div>
              </div>
            )}
          </div>
          {items.setting && (
            <div className="w-[120px] mt-4">
              <div className="flex items-center gap-1">
                <label className="text-sm font-medium text-[#414552]">
                  Price
                </label>
                {items.value === "create" && (
                  <Menu placement="bottom-end">
                    <MenuHandler>
                      <button>
                        <SettingIcon className="w-[12px] h-[12px] fill-gray-600" />
                      </button>
                    </MenuHandler>
                    <MenuList className="outline-remove px-0 py-[8px] min-w-[190px]">
                      <MenuItem
                        className="py-[4px] hover:bg-[#f6f8fa] rounded-none px-[8px] text-[#625afa] font-medium"
                        onClick={() => setItems({ ...items, setting: false })}
                      >
                        Switch to standard pricing
                      </MenuItem>
                    </MenuList>
                  </Menu>
                )}
              </div>
              <div className="flex items-center mt-1 gap-3 w-[220px]">
                <div className="relative w-full">
                  <input
                    type="text"
                    className="input_focus_shadow text-[#404552] font-normal px-2 pl-6 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                    defaultValue="0.00"
                  />
                  <span className="absolute left-2 top-[4px] text-[#404552]">
                    $
                  </span>
                </div>
                <span className="text-sm text-[#687385]">per</span>
                <div className="flex border-[1px] border-[#e0e1e3] rounded-[6px]">
                  <input
                    type="text"
                    className="text-[#404552] rounded-[6px] font-normal px-2 w-full bg-white focus:outline-none h-[30px] text-[14px]"
                    defaultValue="1"
                  />
                  <div className="flex items-center justify-center px-[8px] border-l-[1px] border-[#e0e1e3] text-sm text-[#414552]">
                    unit
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="mt-5">
            <button
              className="flex items-center gap-1 text-[#625afa] font-semibold text-sm"
              onClick={() => setItems({ ...items, options: !items.options })}
            >
              Item options
              {items.options ? (
                <IoChevronUpOutline />
              ) : (
                <IoChevronDownOutline />
              )}
            </button>
            {items.options && (
              <div className="mt-5">
                <div>
                  <span className="font-semibold text-sm text-[#1a1b25]">
                    Item taxes
                  </span>
                  <div className="flex gap-4 mt-1 max-w-[220px] w-full">
                    <Listbox value={taxrate} onChange={setTaxrate}>
                      {({ open }) => (
                        <>
                          <div className="relative w-full">
                            <Listbox.Button className="relative w-full rounded-md bg-white h-[30px] py-[2px] pl-3 pr-10 text-left text-gray-900 shadow-sm font-semibold ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                              <span className="block truncate">
                                {taxrate.name}
                              </span>
                              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-1">
                                <HiChevronUpDown className="text-[20px]" />
                              </span>
                            </Listbox.Button>

                            <Transition
                              show={open}
                              as={Fragment}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 text-base shadow-xl focus:outline-none sm:text-sm">
                                {Taxrate.map((person) => (
                                  <>
                                    <Listbox.Option
                                      key={person.id}
                                      className={({ active }) =>
                                        classNames(
                                          active
                                            ? "bg-[#f6f8fa]"
                                            : "text-[#414552]",
                                          "relative cursor-default select-none py-[6px] pl-3 pr-5"
                                        )
                                      }
                                      value={person}
                                    >
                                      {({ taxrate, active }) => (
                                        <>
                                          <span
                                            className={classNames(
                                              taxrate
                                                ? "font-semibold"
                                                : "font-normal",
                                              "block truncate"
                                            )}
                                          >
                                            {person.name}
                                          </span>

                                          {taxrate ? (
                                            <span
                                              className={classNames(
                                                active
                                                  ? "text-white"
                                                  : "text-indigo-600",
                                                "absolute inset-y-0 right-0 flex items-center pr-4"
                                              )}
                                            ></span>
                                          ) : null}
                                        </>
                                      )}
                                    </Listbox.Option>
                                    <div className="text-sm flex flex-col text-[#414552] border-t-[1px] border-[#ebeef1] relative cursor-default select-none py-[6px] pl-3 pr-5">
                                      <span>No tax rates found. Create a</span>
                                      <button className="flex items-center gap-1 text-[#625afa] font-semibold">
                                        New tax rate
                                        <BiRightArrowAlt className="text-[18px]" />
                                      </button>
                                    </div>
                                  </>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>
                <div className="mt-3">
                  <span className="font-semibold text-sm text-[#1a1b25]">
                    Item coupons
                  </span>
                  <div className="flex gap-4 mt-1 max-w-[220px] w-full">
                    <Listbox value={addC} onChange={setAddC}>
                      {({ open }) => (
                        <>
                          <div className="relative w-full">
                            <Listbox.Button className="relative w-full rounded-md bg-white h-[30px] py-[2px] pl-3 pr-10 text-left text-gray-900 shadow-sm font-semibold ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                              <span className="block truncate">
                                {addC.name}
                              </span>
                              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-1">
                                <HiChevronUpDown className="text-[20px]" />
                              </span>
                            </Listbox.Button>

                            <Transition
                              show={open}
                              as={Fragment}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 text-base shadow-xl focus:outline-none sm:text-sm">
                                {Coupon.map((person) => (
                                  <>
                                    <Listbox.Option
                                      key={person.id}
                                      className={({ active }) =>
                                        classNames(
                                          active
                                            ? "bg-[#f6f8fa]"
                                            : "text-[#414552]",
                                          "relative cursor-default select-none py-[6px] pl-3 pr-5"
                                        )
                                      }
                                      value={person}
                                    >
                                      {({ addC, active }) => (
                                        <>
                                          <span
                                            className={classNames(
                                              addC
                                                ? "font-semibold"
                                                : "font-normal",
                                              "block truncate"
                                            )}
                                          >
                                            {person.name}
                                          </span>

                                          {addC ? (
                                            <span
                                              className={classNames(
                                                active
                                                  ? "text-white"
                                                  : "text-indigo-600",
                                                "absolute inset-y-0 right-0 flex items-center pr-4"
                                              )}
                                            ></span>
                                          ) : null}
                                        </>
                                      )}
                                    </Listbox.Option>
                                    <div className="text-sm flex flex-col text-[#414552] border-t-[1px] border-[#ebeef1] relative cursor-default select-none py-[6px] pl-3 pr-5">
                                      <span>No tax rate found. Create a</span>
                                      <button className="flex items-center gap-1 text-[#625afa] font-semibold">
                                        new tax rate
                                        <BiRightArrowAlt className="text-[18px]" />
                                      </button>
                                    </div>
                                  </>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="flex gap-2 items-center">
                    <label
                      className="inline-flex relative items-center gap-2 cursor-pointer"
                      htmlFor="Invoice-1"
                    >
                      <input
                        type="checkbox"
                        id="Invoice-1"
                        name="Invoice"
                        className="sr-only peer"
                        value={items.checkbox}
                        checked={items.checkbox}
                        onChange={() =>
                          setItems({ ...items, checkbox: !items.checkbox })
                        }
                      />
                      <div className="w-[30px] h-[17px] bg-gray-200 rounded-full peer peer-focus:ring-[#625afa] peer-checked:after:translate-x-[13px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[13px] after:w-[13px] after:transition-all peer-checked:bg-[#625afa]"></div>
                    </label>
                    <label
                      htmlFor="Invoice-1"
                      className="font-semibold text-sm text-[#1a1b25]"
                    >
                      Supply date
                    </label>
                    <Tooltip
                      content={
                        <p>
                          The date that the product or service was provided.
                          Required when different from the invoice issue date.{" "}
                          <span className="text-[#625afa] font-medium">
                            Learn more
                          </span>
                        </p>
                      }
                      className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[12px] max-w-[300px]"
                    >
                      <button>
                        <InfoIcon2 />
                      </button>
                    </Tooltip>
                  </div>
                  <div className="flex gap-3 items-center mt-2">
                    <button
                      disabled={items.checkbox ? false : true}
                      className={`h-[30px] flex items-center gap-2 rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] ${!items.checkbox && "opacity-60"
                        }`}
                    >
                      <GiftIcon className="fill-gray-700" />
                      May 26, 2023
                    </button>
                    <button>
                      <BiRightArrowAlt className="text-[20px] text-gray-500" />
                    </button>
                    <button
                      disabled={items.checkbox ? false : true}
                      className={`h-[30px] flex items-center gap-2 rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] ${!items.checkbox && "opacity-60"
                        }`}
                    >
                      <GiftIcon className="fill-gray-700" />
                      May 26, 2023
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-end gap-3 items-center py-[20px] text-[14px] border-b-[1px] border-[#ebeef1]">
          <button
            className="text-[#625afa] font-semibold"
            onClick={() => setEditItemId('')}
          >
            Cancel
          </button>
          <button className="h-[30px] rounded-[6px] input_focus_shadow font-semibold p-[0_8px] flex items-center gap-2 text-[#414552]">
            Save and add another
          </button>
          <button
            className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] font-semibold p-[0_8px]"
            onClick={() => handleOnchangeSave()}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default EditInvoiceItemList;
